import { Routes, Route } from "react-router-dom";
import { ProtectedRoutes } from "./ProtectedRoutes";
import TaxiRequestProvider from "pages/kiosk/request/features/taxiRequestProvider";
import { KioskLogin } from "pages/common/privateComponents/login";
import { TerminalType_Enum } from "services/sale/common/enums";
import { lazy, Suspense } from "react";
import { TaxiSplashScreen } from "pages/common/privateComponents/taxiSplashScreen/view";
const KioskRoutes = () => {
  // کردن import نحوه
  // -----codesplittng برای
  const TaxiRequest = lazy(() =>
    import("pages/kiosk/request/view").then((module) => ({
      default: module.TaxiRequest,
    }))
  );

  const Receipt = lazy(() =>
    import("pages/kiosk/tripReceipt/view").then((module) => ({
      default: module.Receipt,
    }))
  );

  const Kiosk = lazy(() =>
    import("pages/kiosk/Main/view").then((module) => ({
      default: module.Kiosk,
    }))
  );

  const NotFound = lazy(() =>
    import("pages/common/privateComponents/notFound").then((module) => ({
      default: module.NotFound,
    }))
  );

  return (
    <Suspense fallback={<TaxiSplashScreen />}>
      <Routes>
        <Route
          path="/:id/login"
          element={<KioskLogin paltformType={TerminalType_Enum.Kiosk} />}
        />
        <Route path="/:id/home" element={<Kiosk />} />
        <Route path="*" element={<NotFound />} />
        <Route element={<ProtectedRoutes />}>
          <Route element={<TaxiRequestProvider />}>
            <Route path="/:id/request" element={<TaxiRequest />} />
            <Route path="/:id/payment" element={<Receipt />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
};
export default KioskRoutes;
